<template>
  <div class="form-wrapper">
    <h1>Add User Form</h1>
    <form @submit="addFormToUserPreferences">
      <label for="user-id">User ID</label>
      <textarea
        id="user-id"
        v-model="userListString"
        autofocus
        placeholder="Enter one or more user id or email (separated by comma or newline)"
        required
        type="text"
        class="border-2 p-3"
      />
      <label for="form-type">Form Type</label>
      <VueSelect
        id="form-type"
        v-model="formType"
        :options="formTypeOptions"
        autofocus
        placeholder="Select Form Type"
        required
        type="text"
      />
      <label for="form-key">Form Key</label>
      <VueSelect
        v-model="formKey"
        :options="formKeysOptions"
        placeholder="Select Form Key"
      />
      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-green"
        style="outline: none"
      >
        Add User Form
      </button>
    </form>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  data() {
    return {
      userListString: undefined,
      formType: undefined,
      formTypeOptions: ["home_popup", "contest_popup", "event_popup"],
      formKey: undefined,
      formKeysOptions: [],
    }
  },
  mounted() {
    this.getFormKeys()
  },
  methods: {
    addFormToUserPreferences(e) {
      e.preventDefault()
      this.axios({
        method: "patch",
        url: `${siteConfig.siteURL}admin/user_preferences`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: {
          users_list: this.userListString,
          form_type: this.formType,
          form_key: this.formKey,
        },
      })
        .then(() => {
          this.$noty.success("Successfully created user form!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(() => {
          this.$noty.error("Failed create user form!", {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
    getFormKeys() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}content`,
      }).then(res => {
        this.formKeysOptions = res.data.filter(item =>
          item.startsWith("form-schema-")
        )
      })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  /* text-align: center; */
}
textarea {
  width: 100%;
  height: 150px;
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
button {
  display: block;
  margin: 10px auto;
  text-align: center;
}
</style>
